<app-header></app-header>
<!-- <app-loader [marginTop]="25"></app-loader> -->
<div class="content-wrapper my-5 p-t-25 dis-flex">
  <div *ngIf="isSidebarOpen" class="sidebar">
    <app-sidebar
      (dropdownSelection)="onDropdownSelection($event)"
      [businessThemeLists]="businessThemeLists"
      [teamMembersLists]="teamMembersLists"
      [statusLists]="statusLists"
      [userTypeLists]="userTypeLists"
      [brandLists]="brandLists"
      [isWPSidebar]="true"
       (wpDashboardTeamMembers)="wpListTeamMembers($event)"
      (close)="toggleSidebar()"
    ></app-sidebar>
  </div>
  <div class="main-content p-t-20">
    <div class="container-fluid">
      <div>
        <p-breadcrumb
          class="max-w-full"
          [model]="breadCrumbItems"
          [home]="breadCrumbHome"
        >
          <ng-template pTemplate="item" let-item>
            <p class="b2 m-b-0">{{ item.label }}</p>
          </ng-template>
          <ng-template pTemplate="separator"> / </ng-template>
        </p-breadcrumb>
      </div>
      <div class="dis-flex flex-m flex-sb">
        <h1 class="font-medium m-b-0">All Work Packages</h1>
        <div class="dis-flex">
          <div class="search-box-wrapper">
            <ng-icon
              name="hugeSearch01"
              size="16"
              class="m-r-5 lh-1-0 text-70"
            ></ng-icon>
            <input
              class="radius-8 b2 m-r-20"
              type="text"
              pInputText
              placeholder="Search"
              [(ngModel)]="searchQuery"
              (input)="onSearchInput()"
            />
          </div>
          <!-- <button class="btn outline b2 wd-120px m-r-10">
            <ng-icon
              name="hugeSorting01"
              size="16"
              class="m-r-5 lh-1-0 text-70"
            ></ng-icon>
            Sort
          </button> -->
          <button class="btn outline b2 wd-120px" (click)="toggleSidebar()">
            <ng-icon
              name="hugeFilter"
              size="16"
              class="m-r-5 lh-1-0 text-70"
            ></ng-icon>
            Filters {{ filterCount > 0 ? '(' + filterCount + ')' : '' }}
          </button>
        </div>
      </div>
      <div class="body-card" *ngIf="!loading; else loadingData">
        <div class="w-full">
          <ng-container *ngIf="wpLists?.length > 0; else noWpListFound">
            <app-virtual-scroll
              class="w-full"
              [data]="wpListData"
              [apiUrl]="memberWorkplaceListUrl"
              (loadedData)="onDataLoaded($event)"
            >
              <app-wp
                class="w-full"
                *ngFor="let list of wpLists"
                [wpList]="list"
                [businessThemeLists]="businessThemeLists"
                [brandLists]="brandLists"
                (createFormWP)="createWpFormData($event)"
                (updateFormWP)="updateFormWPFormData($event)"
                [teamMembersLists]="teamMembersLists"
                [userData]="userData?.data"
            ></app-wp>
            </app-virtual-scroll>
            <!-- <app-wp *ngFor="let list of wpLists" [wpList]="list" [userData]="userData?.data" class="w-full"></app-wp> -->
          </ng-container>
        </div>
      </div>

      <app-wp-button
        [businessThemeLists]="businessThemeLists"
        [brandLists]="brandLists"
        (createFormWP)="createWpFormData($event)"
        [teamMembersLists]="teamMembersLists"
        [userData]="userData?.data"
      ></app-wp-button>
    </div>
  </div>
</div>
<ng-template #loadingData>
  <app-shimmer-list></app-shimmer-list>
  <!-- <app-loader></app-loader> -->
</ng-template>

<ng-template #noWpListFound>
  <app-no-data-found></app-no-data-found>
</ng-template>
